import React from 'react';
import { Box, Button } from '@material-ui/core';
import { PlayArrow } from '@material-ui/icons';
import { useStart } from '../hooks';

const Start = () => {
  const { handleStart, startState } = useStart();

  return (
    <Box sx={{ display: 'flex', gridGap: 8 }}>
      <Button
        variant="outlined"
        disabled={startState.loading}
        onClick={() => handleStart({ params: { isMonth: true } })}
        endIcon={<PlayArrow />}
      >
        Start (Месячный)
      </Button>

      <Button
        variant="outlined"
        disabled={startState.loading}
        onClick={() => handleStart({ params: { isKvartal: true } })}
        endIcon={<PlayArrow />}
      >
        Start (Квартальный)
      </Button>
    </Box>
  );
};

export default Start;
